export const PageHeader = ({ title, subtitle, extra, className = "" }) => (
  <header className={`spor-page-header ${className}`}>
    <div className="min-w-0 flex-1">
      <h1 className="spor-page-title">{title}</h1>
      {subtitle && <p className="spor-page-subtitle">{subtitle}</p>}
    </div>
    {extra && <div className="shrink-0">{extra}</div>}
  </header>
);
